<script>
export default {
  name: "LeavePermit",
  inject: ['clearance_0'],
  data() {
    return {
      leave_permit: [
        {
          "date": "2026-05-23T08:30:00Z",
          "fullName": "Juan Carlos Martinez",
          "dni": "0801199912345",
          "type": "Medical Leave",
          "status": "Approved",
          "id": 1001
        },
        {
          "date": "2026-05-24T14:15:00Z",
          "fullName": "Maria Fernanda Lopez",
          "dni": "0801198823456",
          "type": "Vacation",
          "status": "Pending",
          "id": 1002
        },
        {
          "date": "2026-05-25T09:00:00Z",
          "fullName": "Jose Antonio Rivera",
          "dni": "0801200034567",
          "type": "Personal Leave",
          "status": "Rejected",
          "id": 1003
        },
        {
          "date": "2026-05-26T11:45:00Z",
          "fullName": "Ana Sofia Hernandez",
          "dni": "0801199545678",
          "type": "Maternity Leave",
          "status": "Approved",
          "id": 1004
        },
        {
          "date": "2026-05-27T16:20:00Z",
          "fullName": "Luis Enrique Gomez",
          "dni": "0801198767890",
          "type": "Emergency Leave",
          "status": "Pending",
          "id": 1005
        }
      ],
    }
  },
  computed: {
    sidebarData() {
      return this.$store.getters['sidebarData'];
    },
    filteredLeavePermit() {
      if (!this.search) {
        return this.leave_permit;
      }
      return this.leave_permit.filter(leave_permit =>
          leave_permit.name.includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    async getLeavePermitSimpleList() {
      try {
        let result = await this.$api.get("/auth/leave_permit_list")
        if (result.status.toString() === "200") {
          this.leave_permit = result.data
          if (this.leave_permit === null) {
            this.leave_permit = ''
          }
        }
      } catch (error) {
        this.$swal.fire({
          icon: 'error',
          title: '',
          text: 'Ha ocurrido un error obteniendo la información',
          customClass: {
            popup: 'mySwal'
          }
        })
      }
    },
    async getByName() {
      try {
        let res = await this.$api.get("/auth/providers");
        if (res.status.toString() === "200") {
          this.providers = res.data
        }
      } catch (error) {
        console.log("can't get obj data")
      }
    },
    async showInvoice(id) {
      this.$router.push({name: 'ShowInvoice', params: {id: id}})
    },
    inputLimiterSearch() {
      this.search = this.search.replace(/[^a-z0-9 ñáéíóúü,.~\-"']/gi, '').trimStart();
    },
  },
  created() {
    //this.getLeavePermitSimpleList()
  }

}
</script>

<template>
  <div id="section-0" class="container">

    <div class="userSearch">
      <h1>Permisos de Salida</h1>

      <div :class="sidebarData.includes('ad-prov-invoice-reg') ? 'subOpt' : 'subOptCenter'">
        <div>
          <input type="text" v-model="search" v-on:input="inputLimiterSearch" placeholder="Buscar por código ...">
        </div>
        <div>
          <button role="link" @click="$router.push('/scene/register_invoice')"
                  v-if="(sidebarData.includes('ad-prov-invoice-reg'))"
                  :disabled="!(sidebarData.includes('ad-prov-invoice-reg'))">Registrar nuevo permiso de salida
          </button>
        </div>
      </div>


      <div class="table-container mt-4" v-if="leave_permit.length">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>Fecha</th>
            <th>Nombre</th>
            <th>DNI</th>
            <th>Tipo</th>
            <th>Estado</th>
            <th>Opciones</th>


          </tr>

          </thead>
          <tbody>

          <tr v-for="(leave_permit, index) in filteredLeavePermit" :key="leave_permit.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ leave_permit.date.substring(0, 10) }}</td>
            <td>{{ leave_permit.fullName }}</td>
            <td>{{ leave_permit.dni }}</td>
            <td>{{ leave_permit.type }}</td>
            <td>{{leave_permit.status}}</td>
            <td class="td_align_center">
              <button class="tableBtn" @click="showInvoice(leave_permit.id)" role="link">Ver</button>
            </td>
          </tr>

          </tbody>

        </table>
      </div>
      <div v-else>
        <p class="bordered-p">No hay facturas disponibles.</p>
      </div>


    </div>
  </div>


</template>


<style>
.subOpt {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.subOptCenter {
  display: flex;
  justify-content: center;
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

</style>
